import { localStorage } from 'dibs-browser-storage';

import {
    SUSPECTED_TRADE_ACQUISITION_VIEWS,
    SUSPECTED_TRADE_ACQUISITION_MAX_VIEWS,
    SUSPECTED_TRADE_ACQUISITION_DISMISSED,
} from './constants';

function getViewCount() {
    return localStorage.getItem(SUSPECTED_TRADE_ACQUISITION_VIEWS) || 0;
}

export function logView() {
    localStorage.setItem(SUSPECTED_TRADE_ACQUISITION_VIEWS, getViewCount() + 1);
}

function maxViewsCountExceeded() {
    return getViewCount() >= SUSPECTED_TRADE_ACQUISITION_MAX_VIEWS;
}

export function showSuspectedTradeUserAcquisition() {
    return !maxViewsCountExceeded();
}

export function setAcquisitionDismissed() {
    localStorage.setItem(SUSPECTED_TRADE_ACQUISITION_DISMISSED, true);
}

export function isAcquisitionDismissed() {
    return localStorage.getItem(SUSPECTED_TRADE_ACQUISITION_DISMISSED);
}
